import {useState} from 'react'
import useFilters from '../../../hook/useFilters'
import useApi from '../../../services/useApi'
import moment from 'moment'

const useGetIOrdersOverviewData = () => {
  const Api = useApi()
  const [dateRange] = useState(() => JSON.parse(localStorage.getItem('selectedDateRange') || '{}'))

  const initialFilters = {
    start_date: dateRange?.startDate ?? moment().subtract(3, 'months').format('YYYY-MM-DD'),
    end_date: dateRange?.endDate ?? moment().format('YYYY-MM-DD'), // includes today,
  }

  const {filters, onDateChange} = useFilters(initialFilters)

  const {data: response, isFetching} = Api.useGetQuery('/analytics/profitability/orders/wise', {
    filters: filters,
  })

  return {
    ordersOverviewData: response?.data,
    isOrdersOverviewDataLoading: isFetching,
    onOrdersOverviewDateChange: onDateChange,
  }
}

export default useGetIOrdersOverviewData
